<template lang="pug">
  v-container.mb-16
    .text-2xl.font-semibold.my-4.ml-2 Reviews
    review
</template>

<script>
import Review from '@/components/marketing/merchantapp/review/ReviewListingPage.vue'
import {getAuth} from "@/utils";

export default {
  components: {Review},
  mounted() {
    if (!getAuth('root', 'subscribe_review')) {
      this.$router.push({ name: 'NoSubscriptionWarning', params: { plan: 'review' }}).catch(() => {
      })
    }
  },
}
</script>

<style scoped>

</style>